import { render } from "./BaseFeature.vue?vue&type=template&id=92878b9c"
import script from "./BaseFeature.vue?vue&type=script&lang=js"
export * from "./BaseFeature.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__